import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {Tracking, TrackingEvent} from '@common/tracking'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {MenuButtonWithContent} from '../components/menu-button-with-content'
import {ChatsList} from './chats-list'

export const ChatsMenuItem = observer(() => {
  const [open, setOpen] = useState<boolean>(true)
  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'profile',
    {debounceTime: 50, filter: globals.currentUserId},
    () => {
      forceUpdate()
    }
  )
  const toggle = () => {
    setOpen(val => !val)
    void Tracking.send(
      open
        ? TrackingEvent.leftPanelCollapseChatListClick
        : TrackingEvent.leftPanelExpandChatListClick
    )
  }

  return (
    <>
      <MenuButtonWithContent
        text={Lang.msg.menu.chatsHint}
        icon={'IconMessages'}
        onClick={toggle}
        withArrow
        arrowDirection={open ? 'up' : 'down'}
        className="mt-12"
      />
      <ChatsList open={open} />
    </>
  )
})
